import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'objectiveTime'
})
export class ObjectiveTimePipe implements PipeTransform {

  transform(value: string | number, timeType: number): string {
      let formatted: string = "";

      let numberValue = Number(value);
      if (value == null || isNaN(numberValue))
          return "";

      switch (timeType) {
          case 1: //Second
              formatted = value.toString();
              break;
          case 2: //Minute
              formatted = value.toString();
              break;
          case 3: //Hour
              formatted = value.toString();
              break;
          case 4: //Time
              let hours:string|number = Math.floor(numberValue / 3600);
              let minutes: string | number = Math.floor((numberValue - (hours * 3600)) / 60);
              let seconds: string | number = numberValue - (hours * 3600) - (minutes * 60);

              if (hours < 10) { hours = "0" + hours; }
              if (minutes < 10) { minutes = "0" + minutes; }
              if (seconds < 10) { seconds = "0" + seconds; }
              formatted = hours + ':' + minutes + ':' + seconds;
              break;
          case 5: //Percent
              formatted = (numberValue * 100).toFixed(2);
              break;
          default:
              formatted = value.toString();
              break;
      }

      return formatted;
  }
}
